<template>
  <div id="app">
    <Navigation v-if="currentUser"></Navigation>
    <router-view/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Navigation from './components/Navigation.vue'
export default {
  components: { Navigation },
  computed: {
    ...mapState(['currentUser', 'userProfile'])
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
